import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button, Nav, Navbar } from 'react-bootstrap';
import LoginForm from './Login';
import RegisterForm from './Register';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Logo from '../assets/img/xpo_logo.png';
import cartIcon from '../assets/img/cart_icon.png';
import Category from './Category';
import { logout } from '../redux/authSlice';

const Header = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [category, setCategories] = useState([]);
  const [profileMenu, setProfileMenu] = useState(false);
  const menuRef = useRef(null);
  const dispatch = useDispatch();

  // Functions to handle modal show/hide
  const handleLoginClose = () => setShowLogin(false);
  const handleLoginShow = () => {
    setShowRegister(false);
    setShowLogin(true)
  };

  const handleRegisterClose = () => setShowRegister(false);
  const handleRegisterShow = () => {
    setShowLogin(false)
    setShowRegister(true);
  };

  const { cart } = useSelector((state) => state.cart);
  const cartItemCount = cart.reduce((total, item) => total + item.quantity, 0);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const userDetail = useSelector((state) => state.auth);
  
  const makeLogout = () => {
    dispatch(logout());
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setProfileMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []); 

  useEffect(() => {
    if(userDetail?.user?.type == 'success'){
      setShowLogin(false);
      setShowRegister(false);
    }
  },[userDetail.user])
  
  useEffect(() => {
    console.log("userDetail",userDetail);
      // Fetch data from the API
      fetch(`${apiBaseUrl}getcategories`)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((data) => {
          console.log(data.categories);
          setCategories(data.categories);
        })
        .catch((error) => {
          console.log(error)
        });
        console.log("category",category);
    },[]);

  return (
      <header>
        <div className='top-header'></div>
      <Navbar bg="dark" variant="dark" expand="lg" className='p-3'>
        <Navbar.Brand href="/">
            <img src={Logo} alt='logo'/>
        </Navbar.Brand>
        <Link to="/cart" className="nav-link p-0 only-mobile" style={{position: 'relative'}}> <img src={cartIcon} className='cart_icons'/> <sup>({cartItemCount})</sup></Link>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          {/* Center the Nav links */}
          <Nav className="mx-auto">
            <Link to="/" className="nav-link">Home</Link>
            <Category category={category}/>
            {/* <Link to="/checkout" className="nav-link">Checkout</Link> */}
          </Nav>
          {/* Move the buttons to the right */}
          <Nav className="ml-auto">
          <Link to="/cart" className="nav-link p-0 only-desktop" style={{position: 'relative'}}> <img src={cartIcon} className='cart_icons'/> <sup>({cartItemCount})</sup></Link>
            {
              userDetail && userDetail?.user?.type == 'success' ?  (<>
                <div style={{position:"relative"}}>
                <h3 className='profileName' ref={menuRef} onClick={() => setProfileMenu(!profileMenu)}>Hi! {userDetail?.user?.name}</h3>
                {
                  profileMenu && (
                    <>
                    <div className='profileMenu' ref={menuRef}>
                      <ul>
                        <li><Link to='myprofile' className='text-black' style={{textDecoration:'none'}}>My Profile</Link></li>
                        <li onClick={() => makeLogout()}>Logout</li>
                      </ul>
                    </div>
                    </>
                  )
                }
                
                </div>
              </>) 
              : (<>
              <Button variant="outline-light" className='loginbtn' onClick={handleLoginShow}>Login</Button>
              <Button variant="outline-light" className="ml-3 registerbtn" onClick={handleRegisterShow}>Register</Button>
              </>)
            }
            
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      {/* Login Modal */}
      <Modal show={showLogin} onHide={handleLoginClose}>
        {/* <Modal.Header closeButton> */}
          {/* <Modal.Title>Login</Modal.Title> */}
        {/* </Modal.Header> */}
        <Modal.Body>
          <LoginForm />
          <p className='mt-3'>Don't you have account ? <span onClick={handleRegisterShow} className='text-primary' style={{cursor:"pointer"}}>Register Now</span></p>
        </Modal.Body>
      </Modal>

      {/* Register Modal */}
      <Modal show={showRegister} onHide={handleRegisterClose}>
        {/* <Modal.Header closeButton> */}
          {/* <Modal.Title>Register</Modal.Title> */}
        {/* </Modal.Header> */}
        <Modal.Body>
          <RegisterForm />
          <p className='mt-3'>Do you have account ? <span onClick={handleLoginShow} className='text-primary' style={{cursor:"pointer"}}>Sign In</span></p>
        </Modal.Body>
      </Modal>
    </header>
  );
};

export default Header;
